import React from 'react';
import { useParams } from 'react-router-dom';
import { useCouponIssueHistoryDetail } from '../../../hooks/coupon/useCouponIssueHistoryDetail';
import CouponIssueHistoryDetailInfo from '../../coupon/issueHistory/CouponIssueHistoryDetailInfo';
import CouponIssueHistoryDetailItemList from '../../coupon/issueHistory/CouponIssueHistoryDetailItemList';
import { CouponIssueHistoryDetailWrapStyle } from './style';

export const CouponIssueHistoryDetailWrap = () => {
  const { id } = useParams<{ id: string }>();
  const couponIssueHistoryId = Number(id);

  const {
    couponIssueHistoryInfo,
    couponIssueHistoryItemList,
    itemListFilterOption,
    itemListSortOption,
    itemListPagination,
    isLoading,
    onItemListChange,
  } = useCouponIssueHistoryDetail(couponIssueHistoryId);

  if (isLoading) return null;

  return (
    <CouponIssueHistoryDetailWrapStyle className="coupon-issue-history-detail-wrap">
      <CouponIssueHistoryDetailInfo couponIssueHistoryInfo={couponIssueHistoryInfo} />

      <CouponIssueHistoryDetailItemList
        couponIssueHistoryItemList={couponIssueHistoryItemList}
        getCouponIssueHistoryCouponGeneratedList={onItemListChange}
        filterOption={itemListFilterOption}
        sortOption={itemListSortOption}
        pagination={itemListPagination}
      />
    </CouponIssueHistoryDetailWrapStyle>
  );
};
